import { AbstractControl } from '@angular/forms';

export class StringValidators {
    static noWhitespace = (
        control: AbstractControl,
    ): { [key: string]: boolean } | null => {
        const isBlankOrWhitespace =
            control.value == null ||
            (control.value || '').toString().trim().length === 0;

        return isBlankOrWhitespace ? { isBlankOrWhitespace: true } : null;
    };
}
